import { useEffect, useState } from 'react';

/**
 * Returns a `now` timestamp (epoch ms) that ticks every `intervalMs`.
 * One shared interval per component tree where this hook is called,
 * so place it at the page level and pass `now` down.
 *
 * If `serverTimeUtc` is provided, an offset is computed so the timer
 * stays aligned with the server clock.
 */
export function useNowTick(intervalMs = 1000, serverTimeUtc?: string): number {
  const [now, setNow] = useState(() => {
    if (serverTimeUtc) {
      const serverMs = new Date(serverTimeUtc).getTime();
      if (!Number.isNaN(serverMs)) return serverMs;
    }
    return Date.now();
  });

  useEffect(() => {
    if (intervalMs <= 0) return;

    let offset = 0;
    if (serverTimeUtc) {
      const serverMs = new Date(serverTimeUtc).getTime();
      if (!Number.isNaN(serverMs)) {
        offset = serverMs - Date.now();
      }
    }

    const id = setInterval(() => {
      setNow(Date.now() + offset);
    }, intervalMs);

    return () => clearInterval(id);
  }, [intervalMs, serverTimeUtc]);

  return now;
}
